import type { ReactNode } from 'react';
import { cn } from '../ui/cn';

export function PageHeader({ title, description, eyebrow, actions, mono = false, badge, truncateTitle = false }: {
  title: ReactNode; description?: ReactNode; eyebrow?: ReactNode; actions?: ReactNode; mono?: boolean; badge?: ReactNode; truncateTitle?: boolean;
}) {
  return (
    <header className="flex flex-wrap items-end gap-x-6 gap-y-3">
      <div className="min-w-0 flex-1 basis-64">
        {eyebrow && <div className="mb-1.5 text-[13px] text-ink-3">{eyebrow}</div>}
        <div className="flex flex-wrap items-center gap-3">
          <h1 title={truncateTitle && typeof title === 'string' ? title : undefined} className={cn('min-w-0 max-w-full text-[26px] font-semibold leading-tight tracking-tight', truncateTitle ? 'truncate' : 'break-words', mono && 'font-mono text-[24px]')}>{title}</h1>
          {badge}
        </div>
        {description && <p className="mt-1 text-ink-2">{description}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </header>
  );
}
